// @flow
import styled from 'styled-components';
import hexToRgba from 'hex-to-rgba';

import {
  BLACK_COLOR, CLOUDFRONT_STATIC, CSS_BREAKPOINTS_MIN, SPACING_BASE,
} from '../config/constants';
import SYHeadlineFour from './SYHeadlineFour';
import SYHeadlineOne from './SYHeadlineOne';
import SYBody18pt from './SYBody18pt';
import makeImageUrl from '../modules/makeImageUrl';

const OnboardingContainer = styled.section`
  position: relative;
  min-height: calc(100vh - 65px);
  margin: 0 auto;
  padding: 0 ${SPACING_BASE * 3}px;
  margin-bottom: -${SPACING_BASE * 6}px;

  @media ${CSS_BREAKPOINTS_MIN.xs} {
    max-width: 383px;
    min-height: calc(90vh - 65px);
    margin: ${SPACING_BASE * 6}px auto;
    padding: ${SPACING_BASE * 6}px ${SPACING_BASE * 3}px ${SPACING_BASE * 3}px;
    box-shadow: 6px 9px 17px 0 rgba(0, 0, 0, 0.16);
    background-color: ${hexToRgba(BLACK_COLOR, 0.75)};
    background: ${BLACK_COLOR}
      url(${makeImageUrl({ url: `${CLOUDFRONT_STATIC}/img/backgrounds/background-dark-desktop@2x@2x.jpg`, w: 400 })})
      no-repeat
      top right / 100%;
  }

  ${SYHeadlineOne} {
    font-family: 'Poppins-Extra-Light', sans-serif;
    padding-top: ${SPACING_BASE * 4}px;
    font-size: 28px;
    line-height: 1.29;

    strong {
      font-family: 'Poppins-Medium', sans-serif;
    }
  }

  ${SYHeadlineFour} {
    margin: 0 0 ${SPACING_BASE * 6}px;

    @media ${CSS_BREAKPOINTS_MIN.sm} {
      font-size: 20px;
      line-height: 1.25;
      letter-spacing: 0.4px;
    }
  }

  ${SYBody18pt} {
    @media ${CSS_BREAKPOINTS_MIN.sm} {
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  }
`;

export default OnboardingContainer;
